import { graphClient } from '../../graph-client'
import {
  GET_GAME_BOX_ROOM_DETAIL_COUNT,
  GET_GAMES_BOXES_ROOMS_DETAILS,
} from './gql'

import type { GetCount, GetList } from './types'

class GameBoxRoomDetailService {
  async getList({ take = 20, skip = 0, ...params }: GetList.Input) {
    const request = await graphClient.request<GetList.Output>(
      GET_GAMES_BOXES_ROOMS_DETAILS,
      { ...params, skip: take * skip },
    )
    return request?.getGamesBoxesRoomsDetails
  }

  async getCount(params: GetCount.Input) {
    const request = await graphClient.request<GetCount.Output>(
      GET_GAME_BOX_ROOM_DETAIL_COUNT,
      params,
    )

    return request?.getGameBoxRoomDetailCount
  }
}

export const gameBoxRoomDetailService = new GameBoxRoomDetailService()
